"use strict";

function hsAccordionCloseOthers(t, a) {
    for (var i = 0; i < a.length; i++)
        if (a[i] != t && "true" == $(a[i]).attr("aria-expanded")) {
            $(a[i]).attr("aria-expanded", "false");
            var n = $(a[i]).attr("aria-controls");
            $("#" + n).attr("aria-hidden", "true"), $("#" + n).css("display", "none");
            var e = $(a[i]).find(".icon");
            e.hasClass("icon--active") && e.toggleClass("icon--active")
        }
}
Shopify.theme.hsAccordion = {
    init: function t() {
        var a = $(".hs_accordion > dt > button");
        $(".hs_accordion > dd").attr("aria-hidden", !0), a.attr("aria-expanded", !1), a.on("click activate", (function() {
            var t = $(this);
            var a = $(this).find(".icon");
            var i = "false" === $(this).attr("aria-expanded");
            return $(this).attr("aria-expanded", i), $(this).parent().next().slideToggle((function() {
                a.hasClass("icon--active") && a.toggleClass("icon--active")
            })), $(this).parent().next().attr("aria-hidden", !i), !1
        })), a.on("keydown", (function(t) {
            var a;
            13 === (t.keyCode || e.which) && $(this).trigger("activate")
        })), $(a[0]).trigger("click")
        
        // Start ingredients popup - duplicated from z__jsProduct.js / Surface Pickup functionality
        // Copy content from the ingredients accordion tab for display in popup
        const ingredientModal = document.getElementById('hs-ingredient-modal');
        $( "#hs_ingredients_link" ).click(function() {
          event.preventDefault();
          var ingredients_content = document.getElementById('hs_ingredients_popup_content').innerHTML;
          if (!ingredients_content) {
            //console.log("Ingredients not available");
            return;
          }
          document.getElementById('hs-ingredient-modal-content').innerHTML = ingredients_content;
          $.fancybox.open(
            ingredientModal,
            {
              hash: false,
              infobar: false,
              toolbar: false,
              loop: true,
              smallBtn: true,
              buttons: [
                // "zoom",
                // "share",
                // "slideShow",
                // "fullScreen",
                // "download",
                // "thumbs",
                // "close"
              ],
              touch: false,
              video: {
                autoStart: false,
              },
              mobile: {
                preventCaptionOverlap: false,
                toolbar: true,
              },
              beforeShow: () => {
              	document.body.style.top = `-${window.scrollY}px`;
              	document.body.style.position = 'fixed';
              },
              beforeClose: () => {
            	const scrollY = document.body.style.top;
            	document.body.style.position = '';
            	document.body.style.top = '';
            	window.scrollTo(0, parseInt(scrollY || 0, 10) * -1);
              },
            },
           );

        });

    },
    unload: function t() {
        $(".hs_accordion > dt > button").off("click activate"), $(".hs_accordion > dt > button").off("keydown")
    }
};
//# sourceMappingURL=/s/files/1/1380/1279/t/91/assets/hsAccordion.js.map?v=1629504574
